document.addEventListener("DOMContentLoaded", () => {

  // DOM 요소 캐싱 및 존재 여부 확인
  const $homeKV = document.getElementById('homeKV');
  if (!$homeKV) return;

  const $motionEl = document.querySelector('.wrapper');
  const $kvMotionMask = document.querySelector('#kvMotionMask');
  const $line1 = $kvMotionMask.querySelector('.__line1');
  const $line2 = $kvMotionMask.querySelector('.__line2');
  const $rect = $kvMotionMask.querySelector('.__rect');
  const $bgImg = $homeKV.querySelector('.section-bg .__img');
  const $typingArea = $homeKV.querySelector('.__typing-area');
  const $typing = $homeKV.querySelector('.slogan .__typing');
  const $word = $typing?.querySelector('.__word');

  $motionEl.style.clipPath = 'url(#kvMotionMask)';
  $motionEl.style.webkitClipPath = 'url(#kvMotionMask)';

  // intro 모션
  // 성능 최적화된 파라미터 계산
  const calculateParams = (() => {
    let cachedParams = null;
    let lastResize = 0;

    return () => {
      const now = Date.now();
      if (cachedParams && (now - lastResize) < 100) {
        return cachedParams;
      }

      try {
        const homeRequestRect = $homeKV.getBoundingClientRect();

        cachedParams = {
          ww: window.innerWidth,
          wh: window.innerHeight,
          height: homeRequestRect.height,
          cy: homeRequestRect.height / 2 ,
          lh: 60,
          DIFF: 30
        };

        lastResize = now;
        return cachedParams;
      } catch (error) {
        console.warn('Parameter calculation failed:', error);
        return {
          ww: window.innerWidth,
          wh: window.innerHeight,
          height: 600,
          cy: 300,
          lh: 60,
          DIFF: 30
        };
      }
    };
  })();

  let params = calculateParams();

  // 리사이즈 핸들러 최적화
  let resizeTimeout;
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      params = calculateParams();
      try {
        onComplete(); // 애니메이션 완료 상태로 설정
      } catch (error) {
        console.warn('Resize handling failed:', error);
      }
    }, 150);
  };

  window.addEventListener('resize', handleResize, { passive: true });

  // 애니메이션 완료 함수
  function onComplete() {
    try {
      $motionEl.style.clipPath = 'none';
      $motionEl.style.webkitClipPath = 'none';
      // 타이핑 애니메이션 시작 (3초 후)
      try {
        gsap.delayedCall(.1, startTyping);
      } catch (error) {
        console.warn('GSAP delayedCall failed, using setTimeout:', error);
        setTimeout(startTyping, 100);
      }
    } catch (error) {
      console.warn('Animation completion failed:', error);
    }
  }

  // 애니메이션 시작 함수
  function onStart() {
    try {
      gsap.set($line1, {
        attr: {
          d: () => `M 0 ${params.cy - params.lh} L 0 ${params.cy - params.lh} L ${-params.DIFF} ${params.cy} L 0 ${params.cy} Z`
        }
      });
      gsap.set($line2, {
        attr: {
          d: () => `M ${params.ww} ${params.cy} L ${params.ww + params.DIFF} ${params.cy} L ${params.ww} ${params.cy + params.lh} L ${params.ww} ${params.cy + params.lh} Z`
        }
      });
      gsap.set($rect, {
        attr: {
          d: () => `M 0 ${params.cy} L ${params.ww} ${params.cy} L ${params.ww} ${params.cy} L 0 ${params.cy} Z`
        }
      });
      gsap.set($typingArea, {
        clipPath: 'inset(0 0 100% 0)',
      });
    } catch (error) {
      console.warn('Animation start failed:', error);
    }
  }

  // 메인 애니메이션 타임라인
  let motion = null;

  try {
    motion = gsap.timeline({
      paused: true,
      onStart: onStart,
      onComplete: onComplete
    })
        .to($line1, {
          attr: {
            d: () => `M 0 ${params.cy - params.lh} L${params.ww + params.DIFF} ${params.cy - params.lh} L ${params.ww} ${params.cy} L 0 ${params.cy} Z`
          },
          duration: 1,
          ease: 'circ.inOut'
        }, 0)
        .to($line2, {
          attr: {
            d: () => `M ${params.ww} ${params.cy} L${0} ${params.cy} L ${-params.DIFF} ${params.cy + params.lh} L ${params.ww} ${params.cy + params.lh} Z`
          },
          duration: 1,
          ease: 'circ.inOut'
        }, 0)
        .to($rect, {
          attr: {
            d: () => `M 0 0 L ${params.ww} 0 L ${params.ww} ${params.height} L 0 ${params.height} Z`
          },
          duration: 1,
          ease: 'circ.out'
        }, 0.8)

        .to($typingArea, {
          clipPath: "inset(0 0 0% 0)",
          duration: 1.2,
          ease: 'power.out'
        }, 1)


    if (window.DEBUG === true) {
      motion.timeScale(1.4);
      motion.play();
    } else {
      onComplete(); // 애니메이션을 건너뛰고 완료 상태로 설정
    }

  } catch (error) {
    console.warn('Timeline creation failed:', error);
  }


  // 타이핑 애니메이션 설정
  const words = $word.dataset.words?.split(',') || ['Care', 'Happy'];
  const TYPING_SPEED = prefersReducedMotion ? 50 : 100; // 타이핑 속도(ms)
  const WAIT_AFTER_TYPING = prefersReducedMotion ? 1000 : 2200; // 타이핑 후 대기(ms)
  const WAIT_AFTER_DELETING = prefersReducedMotion ? 300 : 600; // 삭제 후 대기(ms)

  let currentWordIndex = 0;
  let currentCharIndex = 0;
  let isDeleting = false;
  let typingTimeout = null;
  let isTypingActive = false;

  // 성능 최적화된 타이핑 함수
  function type() {
    if (!isTypingActive) return;

    try {
      const currentWord = words[currentWordIndex];
      if (!isDeleting) {
        // 타이핑 중
        $word.textContent = currentWord.slice(0, currentCharIndex + 1);
        currentCharIndex++;

        if (currentCharIndex === currentWord.length) {
          isDeleting = true;
          typingTimeout = setTimeout(type, WAIT_AFTER_TYPING);
          return;
        }
        typingTimeout = setTimeout(type, TYPING_SPEED);
      } else {
        // 삭제 중
        $word.textContent = currentWord.slice(0, currentCharIndex - 1);
        currentCharIndex--;

        if (currentCharIndex === 0) {
          isDeleting = false;
          currentWordIndex = (currentWordIndex + 1) % words.length;
          typingTimeout = setTimeout(type, WAIT_AFTER_DELETING);
          return;
        }
        typingTimeout = setTimeout(type, TYPING_SPEED * 0.7);
      }
    } catch (error) {
      console.warn('Typing animation error:', error);
      stopTyping();
    }
  }

  function startTyping() {
    if (prefersReducedMotion) {
      // 접근성: 애니메이션 비활성화 시 정적 표시
      $word.textContent = words[1] || 'Happy';
      return;
    }

    clearTimeout(typingTimeout);
    isTypingActive = true;
    currentWordIndex = 1; // 'Happy'부터 시작
    currentCharIndex = 0;
    isDeleting = false;
    type();
  }

  function stopTyping() {
    isTypingActive = false;
    clearTimeout(typingTimeout);
  }



  // 성능 최적화된 패럴랙스 스크롤
  const updateParallax = (() => {
    return (progress) => {
      const yPercent = progress * 50;
      gsap.set($bgImg, {
        yPercent,
      });
    };
  })();

  // ScrollTrigger 생성 (에러 핸들링 포함)
  try {
    ScrollTrigger.create({
      trigger: $homeKV,
      start: "top top",
      end: "bottom top",
      onUpdate: (self) => {
        if (!prefersReducedMotion) {
          updateParallax(self.progress);
        }
      }
    });
  } catch (error) {
    console.warn('ScrollTrigger creation failed:', error);
  }

});